import React from 'react';
import classNames from 'classnames';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { useSwipeable } from 'react-swipeable';

import { ModalDialogHeaderProps } from '../ModalDialogTypes';

const ModalHeader: React.FC<Omit<ModalDialogHeaderProps, 'headerContent' | 'title' | 'description' | 'id'>> = ({
    children,
    headerClassName,
    hideCloseButton = false,
    onClose,
    type,
    onCloseDownSwipe,
}) => {
    const handlers = useSwipeable({
        onSwipedDown: () => onCloseDownSwipe && onClose?.(),
    });

    return (
        <div className={classNames('sgw-modal-dialog__header', headerClassName)} {...handlers}>
            {type === 'standard' ? (
                <>
                    <div className="sgw-modal-dialog__header-items">{children}</div>
                    <div className="sgw-modal-dialog__header-close-button--align-end">
                        {!hideCloseButton && <IconButton icon={IconTypes.KRYSS_24} onClick={onClose} />}
                    </div>
                </>
            ) : (
                <>
                    <div className="sgw-modal-dialog__header-close-button">
                        {!hideCloseButton && <IconButton icon={IconTypes.BACK} onClick={onClose} />}
                    </div>
                    <div className="sgw-modal-dialog__header-items__sub">{children}</div>
                </>
            )}
        </div>
    );
};

const ModalDialogHeader: React.FC<ModalDialogHeaderProps> = ({ headerContent, borderForHeaderAndFooter, ...rest }) => {
    if (headerContent) {
        return (
            <ModalHeader
                {...rest}
                headerClassName={classNames(rest.headerClassName, 'custom-header', {
                    'with-border': borderForHeaderAndFooter,
                })}
            >
                {headerContent}
            </ModalHeader>
        );
    }

    return <ModalHeader {...rest} />;
};

export default ModalDialogHeader;
